<ng-template #loginModal let-modal>
  <div class="modal-container">
    <h1>Entre com a sua conta</h1>
    <br />
    <form [formGroup]="loginFormGroup">
      <mat-form-field class="form-field" appearance="outline" hideRequiredMarker="true">
        <mat-label>Usuário</mat-label>
        <input
          matInput
          type="email"
          formControlName="email"
          [errorStateMatcher]="matcher"
          placeholder="Ex. eu@exemplo.com.br" />
        @if (email.invalid) {
          <mat-error>{{ getEmailError() }}</mat-error>
        }
      </mat-form-field>
      <mat-form-field class="form-field" appearance="outline" hideRequiredMarker="true">
        <mat-label>Senha</mat-label>
        <input matInput formControlName="password" [errorStateMatcher]="matcher" [type]="hide ? 'password' : 'text'" />
        <button
          mat-icon-button
          matSuffix
          (click)="hide = !hide"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide">
          <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        @if (password.invalid) {
          <mat-error>{{ getPasswordError() }}</mat-error>
        }
      </mat-form-field>
      <div class="login-buttons">
        <button
          mat-raised-button
          color="primary"
          class="loginmodal-login"
          (click)="loginWithEmail()"
          [disabled]="loginFormGroup.invalid || loading">
          Login
        </button>
      </div>
    </form>
    <div class="login-help">
      <a (click)="openRegister()">Registrar novo usuário</a> - <a (click)="openRecover()">Esqueci a senha</a>
    </div>
    @if (wrongLogin) {
      <div class="wrong-login">{{ wrongLogin }}</div>
    }
    <h3 class="traco"><span class="ou"> ou </span></h3>
    <div class="modal-buttons">
      <button mat-raised-button routerLink (click)="loginWithGoogle()" [disabled]="loading">
        <div class="registerModal-icon google-icon"></div>
        <span>Entrar com Google</span>
      </button>
      <button mat-raised-button routerLink (click)="loginWithFacebook()" [disabled]="loading">
        <div class="registerModal-icon facebook-icon"></div>
        <span>Entrar com Facebook</span>
      </button>
    </div>
  </div>
</ng-template>
<ng-template #registerModal let-modal>
  <div class="modal-container">
    <h1>Cadastrar novo usuário</h1>
    <p>Escolha o método que gostaria de se cadastrar</p>
    <div class="modal-buttons">
      <button mat-raised-button routerLink cdkFocusRegionStart (click)="open(registerEmailModal)" [disabled]="loading">
        <mat-icon class="registerModal-icon email-icon">email_outline</mat-icon>
        <span>Email e Senha</span>
      </button>
      <button mat-raised-button routerLink (click)="loginWithGoogle()" [disabled]="loading">
        <div class="registerModal-icon google-icon"></div>
        <span>Login do Google</span>
      </button>
      <button mat-raised-button routerLink (click)="loginWithFacebook()" [disabled]="loading">
        <div class="registerModal-icon facebook-icon"></div>
        <span>Login do Facebook</span>
      </button>
    </div>
  </div>
</ng-template>
<ng-template #registerEmailModal let-modal>
  <div class="modal-container">
    <h1>Registrar novo login</h1>
    <br />
    <form [formGroup]="loginFormGroup">
      <mat-form-field class="form-field" hideRequiredMarker="true">
        <mat-label>E-mail</mat-label>
        <input
          matInput
          type="email"
          formControlName="email"
          [errorStateMatcher]="matcher"
          placeholder="Ex. eu@exemplo.com.br" />
        @if (email.invalid && !loginFormGroup.pristine) {
          <mat-error>{{ getEmailError() }}</mat-error>
        }
      </mat-form-field>
      <mat-form-field class="form-field" hideRequiredMarker="true">
        <mat-label>Senha</mat-label>
        <input matInput formControlName="password" [errorStateMatcher]="matcher" [type]="hide ? 'password' : 'text'" />
        <button
          mat-icon-button
          matSuffix
          (click)="hide = !hide"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide">
          <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        @if (password.invalid) {
          <mat-error>{{ getPasswordError() }}</mat-error>
        }
      </mat-form-field>
      <div class="registerEmailModal-buttons">
        <button mat-raised-button (click)="dismissModal()" [disabled]="loading">Cancelar</button>
        <button mat-raised-button color="primary" (click)="registerWithEmail()" [disabled]="!loginFormGroup.valid">
          Registrar
        </button>
      </div>
    </form>
  </div>
</ng-template>
<ng-template #recoverModal let-modal>
  <div class="modal-container">
    <h1>Recuperar senha</h1>
    <p>
      Caso você já tenha cadastro utilizando seu e-mail e esqueceu a senha, preencha com seu e-mail abaixo para que
      possamos enviar as instruções para recuperar sua senha.
    </p>
    <form [formGroup]="loginFormGroup">
      <mat-form-field class="form-field" hideRequiredMarker="true">
        <mat-label>E-mail</mat-label>
        <input
          matInput
          type="email"
          formControlName="email"
          [errorStateMatcher]="matcher"
          placeholder="Ex. eu@exemplo.com.br" />
      </mat-form-field>
      <div class="registerEmailModal-buttons">
        <button mat-raised-button (click)="openLogin()" [disabled]="loading">Voltar</button>
        <button mat-raised-button color="primary" (click)="recoverPassword()" [disabled]="!email?.valid || loading">
          Recuperar
        </button>
      </div>
    </form>
    @if (errorMessage) {
      <ngb-alert type="danger" (close)="closeError()">{{ errorMessage }}</ngb-alert>
    }
  </div>
</ng-template>
